module.exports = __webpack_public_path__ + "img/assiant_2wml.6af51317.png";